/**
 * Graphic Dots
 * ------------
 */

let graphicDots = $('.graphic-dot');

if(graphicDots.length) {

    function checkDots() {

        let scrollPosition = document.documentElement.scrollTop,
            windowHeight = $(window).outerHeight();

        graphicDots.each(function () {
            let _this = $(this);

            // let delay = Math.floor((Math.random() * 10) + 1) * 1000;
            //
            // setTimeout(function () {
            //
            //     setInterval(function () {
            //         if(_this.hasClass('bounce')) {
            //             _this.removeClass('bounce');
            //             setTimeout(function () {
            //                 _this.addClass('bounce');
            //             }, 1000);
            //         }
            //
            //         if(_this.hasClass('rubberBand')) {
            //             _this.removeClass('rubberBand');
            //             setTimeout(function () {
            //                 _this.addClass('rubberBand');
            //             }, 1000);
            //         }
            //
            //         if(_this.hasClass('wobble')) {
            //             _this.removeClass('wobble');
            //             setTimeout(function () {
            //                 _this.addClass('wobble');
            //             }, 1000);
            //         }
            //
            //         if(_this.hasClass('swing')) {
            //             _this.removeClass('swing');
            //             setTimeout(function () {
            //                 _this.addClass('swing');
            //             }, 1000);
            //         }
            //     }, 5000);
            //
            // }, delay);

            if(!$(this).hasClass('has-been-triggered')) {
                if( ($(this).offset().top < (scrollPosition + windowHeight)) && ($(this).offset().top > scrollPosition) ) {
                    setTimeout(function () {
                        _this.addClass('has-been-triggered');

                        if(_this.hasClass('has-animation-bounce')) {
                            _this.addClass('bounce');
                        }

                        if(_this.hasClass('has-animation-rubberBand')) {
                            _this.addClass('rubberBand');
                        }

                        if(_this.hasClass('has-animation-wobble')) {
                            _this.addClass('wobble');
                        }

                        if(_this.hasClass('has-animation-swing')) {
                            _this.addClass('swing');
                        }

                    }, 500);
                }
            }
            // console.log(scrollPosition);
            // console.log();
        });

    }

    checkDots();

    $(window).on('scroll', function () {
        checkDots();
    });

}